import type { DateWithItinerary } from '@apps/main/new-desktop/core/stores/trip/tripStore.model';

import { SemboDate } from '@libs/sembo-dates';

export function getMonthStartAndEndDates(date: Date): {
  startDate: Date;
  endDate: Date;
  selectedDate: undefined;
} {
  const year = date.getFullYear();
  const month = date.getMonth();
  const startDate = new Date(year, month, 1);
  const endDate = new Date(year, month + 1, 0);
  return { startDate, endDate, selectedDate: undefined };
}

export function doesDateMatchAnyComparisonDate(
  date: Date,
  comparisonDates: Array<Date | undefined>
): boolean {
  for (const comparisonDate of comparisonDates) {
    if (comparisonDate) {
      return new SemboDate(date).isSameDay(comparisonDate);
    }
  }

  return false;
}

export function getDateOfCheapestItinerary(
  datesWithItineraries: DateWithItinerary[]
): Date | undefined {
  const result = datesWithItineraries.reduce<{
    date: Date | undefined;
    price: number;
  }>(
    (currentBest, current) => {
      const price = current.itinerary?.totalPrice?.amount;
      if (price !== undefined && price < currentBest.price) {
        return { date: current.date, price };
      }
      return currentBest;
    },
    { date: undefined, price: Number.MAX_SAFE_INTEGER }
  );

  return result.date;
}
